import React, { createContext, useCallback, useEffect, useState } from 'react';
import TerminalService from 'services/TerminalServices';

export const TerminalContext = createContext();

function TerminalProvider({ children }) {
  const [terminals, setTerminals] = useState([]);
  const [selectedTerminal, setSelectedTerminal] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getTerminals = useCallback(
    async (params = {}) => {
      setIsLoading(true);
      try {
        const resp = await TerminalService.getTerminals(params);
        setTerminals(resp);

        // If no terminal is selected, or the current selected terminal is not in the list,
        // set the default terminal (first terminal without auth_token)
        if (resp && resp.length > 0) {
          const defaultTerminal = resp.find((t) => !t.auth_token) || null;
          if (!selectedTerminal || !resp.find((t) => t.id === selectedTerminal.id)) {
            setSelectedTerminal(defaultTerminal);
          }
        }
        return resp;
      } catch (error) {
        console.error('Failed to fetch terminals:', error);
        return [];
      } finally {
        setIsLoading(false);
      }
    },
    [selectedTerminal]
  );

  useEffect(() => {
    getTerminals();
  }, [getTerminals]);

  return (
    <TerminalContext.Provider
      value={{
        terminals,
        selectedTerminal,
        setSelectedTerminal,
        getTerminals,
        isLoadingTerminals: isLoading,
      }}
    >
      {children}
    </TerminalContext.Provider>
  );
}

export default TerminalProvider;
